import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BannerAdvancedComponent } from './banner-advanced.component';

const routes: Routes = [{ path: '', component: BannerAdvancedComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BannerAdvancedRoutingModule { }
